<template>
   <el-dialog :visible.sync="innerVisible" width="80%" :modal=false title="请选择商品">
    <!-- 卡片视图区域 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input placeholder="请输入商品名称" v-model="queryInfo.query" clearable @clear="getGoodsList">
            <!-- <el-button slot="append" icon="el-icon-search" @click="getGoodsList"></el-button> -->
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.school_sign" placeholder="学标奶">
                <el-option
                  v-for="item in xuebiao"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.status" placeholder="上架状态">
                <el-option
                  v-for="item in shangjia"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.jxtype" placeholder="经销渠道">
                <el-option
                  v-for="item in jxtypelist"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="getGoodsList">搜索</el-button>
          <!-- <div class="tip">添加低温商品前，请先设置截止时间</div> -->
        </el-col>
      </el-row>

      <!-- table表格区域 -->
      <el-table :data="goodslist" border stripe max-height="440" ref="registTable">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="商品名称" prop="title"></el-table-column>
        <el-table-column label="商品类型" prop="type" width="80px"></el-table-column>
        <el-table-column label="学标奶" prop="school_sign" width="80px" align="center"></el-table-column>
        <el-table-column label="商品编号" prop="number" width="100px"></el-table-column>
        <!-- <el-table-column label="封面" width="120px" align="center">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.fengmian" fit="contain"></el-image>
          </template>
        </el-table-column> -->
        <el-table-column label="商品价格" align="center" prop="price" width="95px"></el-table-column>
        <el-table-column label="商品库存" prop="kucun" width="70px"></el-table-column>
        <el-table-column label="经销渠道" align="center" prop="jxtype" width="70px"></el-table-column>
        <el-table-column label="单位" align="center" prop="unit" width="70px"></el-table-column>
        <el-table-column label="重量系数" prop="weight" width="90px"></el-table-column>
        <el-table-column label="规格" prop="preNum" width="90px"></el-table-column>
        <el-table-column label="创建时间" prop="create_at" width="130px">
        </el-table-column>
        <el-table-column label="上架状态" width="100px" v-if="canLook == 1">
          <!-- <el-tag type="success" :value="scope.row.status">上架</el-tag> -->
          <!-- <el-tag :visible="scope.row.status" type="danger">下架</el-tag> -->
          <template slot-scope="scope">
            <el-tag  v-if="scope.row.status==1" type="success">上架</el-tag>
             <el-tag  v-if="scope.row.status==0" type="danger">下架</el-tag>
            <!-- <el-switch v-model="scope.row.status" @change="goodStateChanged(scope.row)"> </el-switch> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20,50,100,500]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
    <div style="margin-top: 20px">
      <el-button @click="okSelection()">确定</el-button>
      <el-button  @click="innerVisible = false">取消</el-button>
    </div>
   </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      //------------------
      innerVisible: this.visible,
        //callBackData: {},
        // tableData: [{
        //   date: '2016-05-03',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-02',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-04',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-01',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-08',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-06',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-07',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }],
        //multipleSelection: []
      //------------------
      canLook: 1,
      // 查询参数对象
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 100
      },
      xuebiao:[
          {id:'',label:'全部'},
          {id:1,label:'学标奶'},
          {id:2,label:'非学标奶'},
        ],
      shangjia:[
          {id:'',label:'全部'},
          {id:1,label:'上架'},
          {id:2,label:'未上架'},
        ],
      jxtypelist:[
          {id:'',label:'全部'},
          {id:1,label:'团购'},
          {id:2,label:'校园'},
        ],
      // 商品列表
      goodslist: [],
      exportUrl: 'https://hsapi.hsxsn.cn//exportGoodsList?mPhone=' + localStorage.getItem('phone'),
      // 总数据条数
      total: 0
    }
  },
  //-------------------
  props: {
      valueId: {
        type: String,
        default: ''
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      visible(val, oldVal) {
        if (val === oldVal) {
          return
        }
        console.log('in-'+this.valueId)
        // if (val) {
        //   // 重置表单
        //   this.resetFields()
        //   // 获取数据
        //   if (this.valueId) {
        //     this.getDetail()
        //   }
        // }
        this.innerVisible = val
      },
      // 如果内部有新值变化，更新外部visible
      innerVisible(val, oldVal) {
        if (val === oldVal) {
          return
        }
        this.$emit('update:visible', val)
      }
    },
  //-------------------
  created () {
    this.getGoodsList()
  },
  methods: {
    //----------------
    async okSelection() {
        console.log(this.$refs.registTable.selection);
        let okSelection=this.$refs.registTable.selection;
        if(okSelection.length>0){
          console.log('in');
          const { data: res } = await this.$http.post('admin/order/addgoods', {id: this.valueId ,selection:okSelection})
          console.log(res);
          if (res.code !== 200) {
            return this.$message.error('操作无效!');
          }
          this.$message.success('操作成功!');
        }
        this.innerVisible = false;
      },
    //----------------
    // 根据分页获取对应的商品列表
    async getGoodsList () {
      const { data: res } = await this.$http.post('admin/good/list', {
        params: this.queryInfo
      })

      if (res.code !== 200) {
        return this.$message.error('获取商品列表失败！')
      }

      this.$message.success('获取商品列表成功！')
      console.log(res.result)
      this.goodslist = res.result.list
      this.total = res.result.count
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getGoodsList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getGoodsList()
    },
    // async removeById (id) {
    //   const confirmResult = await this.$confirm(
    //     '此操作将永久删除该商品, 是否继续?',
    //     '提示',
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }
    //   ).catch(err => err)
    //   if (confirmResult !== 'confirm') {
    //     return this.$message.info('已经取消删除！')
    //   }
    //   const { data: res } = await this.$http.post('admin/good/delete', { id: id })
    //   if (res.code !== 200) {
    //     return this.$message.error('删除失败！')
    //   }
    //   this.$message.success('删除成功！')
    //   this.getGoodsList()
    // },

    // 监听 switch 开关状态的改变
    // async goodStateChanged (userinfo) {
    //   console.log(userinfo)
    //   const { data: res } = await this.$http.post('/admin/good/updateStatus', {
    //     status: userinfo.status,
    //     id: userinfo.id
    //   })
    //   if (res.code !== 200) {
    //     userinfo.mg_state = !userinfo.mg_state
    //     return this.$message.error('更新商品状态失败！')
    //   }
    //   this.$message.success('更新商品状态成功！')
    // },

    // goAddpage () {
    //   this.$router.push('/goods/add')
    // },

    // 低温商品截止时间设置
    // goToSetEndTime () {
    //   this.$router.push('/goods/dwGoodEndTime')
    // },

    // 低温商品税率
    // goToSetShui () {
    //   this.$router.push('/goods/setGoodInvoice')
    // },

    // 编辑
    // editById (id) {
    //   console.log(id);
    //   this.$router.push({ path: '/goods/add', query: { id: id } })

    // }
  }
}
</script>

<style lang="less" scoped>
.tip {
  font-size: 13px;
  color: #cccccc;
}
</style>
